var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v("개체등록")])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "detail",
              expression: "data.params.mode=='detail'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("form", { attrs: { "data-vv-scope": "edit" } }, [
              _c("table", { staticClass: "table table-bordered" }, [
                _c("colgroup", [
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "15%" }
                  }),
                  _c("col", { attrs: { width: "35%" } }),
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "15%" }
                  }),
                  _c("col", { attrs: { width: "35%" } })
                ]),
                _c("tr", [
                  _c("th", [_vm._v("개체유형 선택*")]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.fileTypeCd,
                            expression: "data.row.fileTypeCd"
                          }
                        ],
                        staticClass: "ml-2",
                        attrs: {
                          id: "textFile",
                          type: "checkbox",
                          name: "fileKind",
                          "true-value": "211001"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.fileTypeCd)
                            ? _vm._i(_vm.data.row.fileTypeCd, null) > -1
                            : _vm._q(_vm.data.row.fileTypeCd, "211001")
                        },
                        on: {
                          click: function($event) {
                            _vm.AllClearCheck()
                            _vm.docFile = true
                            _vm.data.row.fileTypeCd = "211001"
                          },
                          change: function($event) {
                            var $$a = _vm.data.row.fileTypeCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? "211001" : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "fileTypeCd", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-labe ml-1",
                          attrs: { for: "textFile" }
                        },
                        [_vm._v("문서파일")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.fileTypeCd,
                            expression: "data.row.fileTypeCd"
                          }
                        ],
                        staticClass: "ml-2",
                        attrs: {
                          id: "mediaFile",
                          type: "checkbox",
                          name: "fileKind",
                          "true-value": "211002"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.fileTypeCd)
                            ? _vm._i(_vm.data.row.fileTypeCd, null) > -1
                            : _vm._q(_vm.data.row.fileTypeCd, "211002")
                        },
                        on: {
                          click: function($event) {
                            _vm.AllClearCheck()
                            _vm.mediaFile = true
                            _vm.data.row.fileTypeCd = "211002"
                          },
                          change: function($event) {
                            var $$a = _vm.data.row.fileTypeCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? "211002" : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "fileTypeCd", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-labe ml-1",
                          attrs: { for: "mediaFile" }
                        },
                        [_vm._v("멀티미디어(mp3,mp4)")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.fileTypeCd,
                            expression: "data.row.fileTypeCd"
                          }
                        ],
                        staticClass: "ml-2",
                        attrs: {
                          id: "fileUrl",
                          type: "checkbox",
                          name: "fileKind",
                          "true-value": "211003"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.fileTypeCd)
                            ? _vm._i(_vm.data.row.fileTypeCd, null) > -1
                            : _vm._q(_vm.data.row.fileTypeCd, "211003")
                        },
                        on: {
                          click: function($event) {
                            _vm.AllClearCheck()
                            _vm.exterUrl = true
                            _vm.data.row.fileTypeCd = "211003"
                          },
                          change: function($event) {
                            var $$a = _vm.data.row.fileTypeCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? "211003" : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "fileTypeCd", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-labe ml-1",
                          attrs: { for: "fileUrl" }
                        },
                        [_vm._v("외부링크")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.fileTypeCd,
                            expression: "data.row.fileTypeCd"
                          }
                        ],
                        staticClass: "ml-2",
                        attrs: {
                          id: "contentsUrl",
                          type: "checkbox",
                          name: "fileKind",
                          "true-value": "211004"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.fileTypeCd)
                            ? _vm._i(_vm.data.row.fileTypeCd, null) > -1
                            : _vm._q(_vm.data.row.fileTypeCd, "211004")
                        },
                        on: {
                          click: function($event) {
                            _vm.AllClearCheck()
                            _vm.contentsUrl = true
                            _vm.data.row.fileTypeCd = "211004"
                          },
                          change: function($event) {
                            var $$a = _vm.data.row.fileTypeCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? "211004" : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "fileTypeCd", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-labe ml-1",
                          attrs: { for: "contentsUrl" }
                        },
                        [_vm._v("콘텐츠링크")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.fileTypeCd,
                            expression: "data.row.fileTypeCd"
                          }
                        ],
                        staticClass: "ml-2",
                        attrs: {
                          id: "zipFile",
                          type: "checkbox",
                          name: "fileKind",
                          "true-value": "211005"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.fileTypeCd)
                            ? _vm._i(_vm.data.row.fileTypeCd, null) > -1
                            : _vm._q(_vm.data.row.fileTypeCd, "211005")
                        },
                        on: {
                          click: function($event) {
                            _vm.AllClearCheck()
                            _vm.webContents = true
                            _vm.data.row.fileTypeCd = "211005"
                          },
                          change: function($event) {
                            var $$a = _vm.data.row.fileTypeCd,
                              $$el = $event.target,
                              $$c = $$el.checked ? "211005" : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "fileTypeCd",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "fileTypeCd", $$c)
                            }
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-labe ml-1",
                          attrs: { for: "zipFile" }
                        },
                        [_vm._v("웹콘텐츠 등록(zip)")]
                      )
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("th", [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.exterUrl && !_vm.contentsUrl,
                            expression: "!exterUrl && !contentsUrl"
                          }
                        ]
                      },
                      [_vm._v(" 원본파일*")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.exterUrl || _vm.contentsUrl,
                            expression: "exterUrl || contentsUrl"
                          }
                        ]
                      },
                      [_vm._v(" 링크경로*")]
                    )
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.exterUrl && !_vm.contentsUrl,
                            expression: "!exterUrl && !contentsUrl"
                          }
                        ],
                        staticClass: "custom-file",
                        staticStyle: { height: "2.1875rem" }
                      },
                      [
                        _c("input", {
                          ref: "file",
                          staticClass: "display-file",
                          attrs: { type: "file", id: "newfile" },
                          on: { change: _vm.insertFileName }
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "custom-file-label",
                            attrs: { for: "newfile" }
                          },
                          [_vm._v("Choose a file...")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2",
                            staticStyle: { "margin-top": "20px !important" }
                          },
                          [_vm._v(_vm._s(_vm.fileName))]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.exterUrl || _vm.contentsUrl,
                            expression: "exterUrl || contentsUrl"
                          }
                        ]
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.row.linkUrl,
                              expression: "data.row.linkUrl"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''"
                            }
                          ],
                          class: {
                            "form-control": true,
                            "is-invalid": _vm.errors.has("edit.extFileId")
                          },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "text",
                            name: "newfile",
                            placeholder: "Url..."
                          },
                          domProps: { value: _vm.data.row.linkUrl },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.row,
                                "linkUrl",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.webContents,
                            expression: "webContents"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "※ 웹콘텐츠(ZIP) 압축파일 등록 시 압축 해제 및 서비스 가능 상태 변경에 시간이 소요됩니다."
                        )
                      ]
                    )
                  ])
                ]),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.exterUrl && !_vm.contentsUrl,
                        expression: "!exterUrl && !contentsUrl"
                      }
                    ]
                  },
                  [
                    _c("th", [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.exterUrl && !_vm.contentsUrl,
                              expression: "!exterUrl && !contentsUrl"
                            }
                          ]
                        },
                        [_vm._v("미리보기파일")]
                      )
                    ]),
                    _c("td", { attrs: { colspan: "3" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.exterUrl && !_vm.contentsUrl,
                              expression: "!exterUrl && !contentsUrl"
                            }
                          ],
                          staticClass: "custom-file",
                          staticStyle: { height: "2.1875rem" }
                        },
                        [
                          _c("div", { staticClass: "form-check mb-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.row.contentsViewFileUploadYn,
                                  expression:
                                    "data.row.contentsViewFileUploadYn"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                "true-value": "Y",
                                "false-value": "N",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.data.row.contentsViewFileUploadYn
                                )
                                  ? _vm._i(
                                      _vm.data.row.contentsViewFileUploadYn,
                                      null
                                    ) > -1
                                  : _vm._q(
                                      _vm.data.row.contentsViewFileUploadYn,
                                      "Y"
                                    )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.checkPreviewUpload()
                                },
                                change: function($event) {
                                  var $$a =
                                      _vm.data.row.contentsViewFileUploadYn,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? "Y" : "N"
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data.row,
                                          "contentsViewFileUploadYn",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data.row,
                                          "contentsViewFileUploadYn",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.data.row,
                                      "contentsViewFileUploadYn",
                                      $$c
                                    )
                                  }
                                }
                              }
                            }),
                            _c("label", { staticClass: "form-check-label" }, [
                              _vm._v(
                                "VIEW용 PDF 업로드(첨부파일이 PDF로 변환이 불가한 경우)"
                              )
                            ])
                          ]),
                          _c("input", {
                            ref: "file",
                            staticClass: "display-file",
                            attrs: {
                              type: "file",
                              accept: ".pdf",
                              disabled: _vm.previewUploadYN == false,
                              id: "previewNewFile"
                            },
                            on: { change: _vm.insertPreviewFileName }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              style: {
                                backgroundColor:
                                  _vm.previewUploadYN == false
                                    ? "lightgray"
                                    : ""
                              },
                              attrs: { for: "previewNewFile" }
                            },
                            [_vm._v("Choose a file...")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "mt-2",
                              staticStyle: { "margin-top": "20px !important" }
                            },
                            [_vm._v(_vm._s(_vm.previewFileName))]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c("tr", [
                  _c("th", [_c("span", [_vm._v("썸네일링크")])]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.row.thumbnailPath,
                          expression: "data.row.thumbnailPath"
                        }
                      ],
                      class: { "form-control": true },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        name: "thumbnailPath",
                        placeholder: "Url..."
                      },
                      domProps: { value: _vm.data.row.thumbnailPath },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.data.row,
                            "thumbnailPath",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th", [_vm._v("노출개체명*")]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.row.dispFileNm,
                          expression: "data.row.dispFileNm"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''"
                        }
                      ],
                      class: {
                        "form-control": true,
                        "is-invalid": _vm.errors.has("edit.dispFileNm")
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        placeholder: "dispFileNm",
                        name: "dispFileNm"
                      },
                      domProps: { value: _vm.data.row.dispFileNm },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.data.row,
                            "dispFileNm",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("edit.dispFileNm"),
                            expression: "errors.has('edit.dispFileNm')"
                          }
                        ],
                        staticClass: "invalid-feedback"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("edit.dispFileNm")))]
                    )
                  ])
                ]),
                _c("tr", [
                  _c("th", [_vm._v("노출대상 설정")]),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("b-input-group", [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "form-check ml-2",
                              staticStyle: {
                                display: "flex",
                                "padding-left": "unset"
                              }
                            },
                            [
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.data.row.teacherUseYn,
                                      expression: "data.row.teacherUseYn"
                                    }
                                  ],
                                  staticClass: "form-check-input ml-2",
                                  attrs: {
                                    "true-value": "Y",
                                    "false-value": "N",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.data.row.teacherUseYn
                                    )
                                      ? _vm._i(
                                          _vm.data.row.teacherUseYn,
                                          null
                                        ) > -1
                                      : _vm._q(_vm.data.row.teacherUseYn, "Y")
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.data.row.teacherUseYn,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? "Y" : "N"
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "teacherUseYn",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "teacherUseYn",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.data.row,
                                          "teacherUseYn",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  { staticClass: "form-check-label ml-4" },
                                  [_vm._v("교사사용")]
                                )
                              ]),
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.data.row.tutorUseYn,
                                      expression: "data.row.tutorUseYn"
                                    }
                                  ],
                                  staticClass: "form-check-input ml-2",
                                  attrs: {
                                    "true-value": "Y",
                                    "false-value": "N",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.data.row.tutorUseYn
                                    )
                                      ? _vm._i(_vm.data.row.tutorUseYn, null) >
                                        -1
                                      : _vm._q(_vm.data.row.tutorUseYn, "Y")
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.data.row.tutorUseYn,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? "Y" : "N"
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "tutorUseYn",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "tutorUseYn",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.data.row,
                                          "tutorUseYn",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  { staticClass: "form-check-label ml-4" },
                                  [_vm._v("강사사용")]
                                )
                              ]),
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.data.row.studentUseYn,
                                      expression: "data.row.studentUseYn"
                                    }
                                  ],
                                  staticClass: "form-check-input ml-2",
                                  attrs: {
                                    "true-value": "Y",
                                    "false-value": "N",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.data.row.studentUseYn
                                    )
                                      ? _vm._i(
                                          _vm.data.row.studentUseYn,
                                          null
                                        ) > -1
                                      : _vm._q(_vm.data.row.studentUseYn, "Y")
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.data.row.studentUseYn,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? "Y" : "N"
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "studentUseYn",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.data.row,
                                              "studentUseYn",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.data.row,
                                          "studentUseYn",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  { staticClass: "form-check-label ml-4" },
                                  [_vm._v("학생사용")]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _c("tr", [
                  _c("th", [_vm._v("키워드")]),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("Keyword", {
                        key: _vm.keywords.text,
                        attrs: {
                          box: _vm.keywords.box,
                          boxText: _vm.keywords.text,
                          type: "key"
                        },
                        on: {
                          keywordChange: _vm.keywordChange,
                          keywordRemove: _vm.keywordRemove
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("tr", [
                  _c("th", [_vm._v("태그")]),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("Keyword", {
                        key: _vm.tags.text,
                        attrs: {
                          box: _vm.tags.box,
                          boxText: _vm.tags.text,
                          type: "tag"
                        },
                        on: {
                          keywordChange: _vm.keywordChange,
                          keywordRemove: _vm.keywordRemove
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _c("div", [
        _c("div", { staticClass: "content-heading mt-1", attrs: { div: "" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.contSeq,
                  expression: "contSeq"
                }
              ]
            },
            [_vm._v("매핑정보")]
          )
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contSeq,
                expression: "contSeq"
              }
            ],
            staticClass: "card card-default"
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("form", { attrs: { "data-vv-scope": "edit" } }, [
                _c("table", { staticClass: "table table-bordered" }, [
                  _c("colgroup", [
                    _c("col", {
                      staticClass: "bg-lightdark",
                      attrs: { width: "15%" }
                    }),
                    _c("col", { attrs: { width: "35%" } }),
                    _c("col", {
                      staticClass: "bg-lightdark",
                      attrs: { width: "15%" }
                    }),
                    _c("col", { attrs: { width: "35%" } })
                  ]),
                  _c("tr", [
                    _c("th", [_vm._v("콘텐츠 용도 *")]),
                    _c(
                      "td",
                      [
                        _c("b-input-group", [
                          _c(
                            "div",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.exterUrl
                                    ? _vm.purpTypeCd_exterUrl
                                    : _vm.purpTypeCd
                                },
                                on: {
                                  change: function($event) {
                                    _vm.exterUrl_addition1 =
                                      _vm.data.row.purpTypeCd == "209007"
                                    _vm.exterUrl_addition2 = false
                                    _vm.exterUrl_addition3 = false
                                    _vm.data.row.purpTypeCd_sub1 = undefined
                                    _vm.data.row.purpTypeCd_sub2 = undefined
                                    _vm.data.row.purpTypeCd_sub3 = undefined
                                    _vm.purpTypeCd_sub1_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                      function(cd) {
                                        return (
                                          _vm.data.row.purpTypeCd &&
                                          cd.p_code.endsWith(
                                            _vm.data.row.purpTypeCd
                                          )
                                        )
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.data.row.purpTypeCd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data.row, "purpTypeCd", $$v)
                                  },
                                  expression: "data.row.purpTypeCd"
                                }
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.exterUrl && _vm.exterUrl_addition1,
                                      expression:
                                        "exterUrl && exterUrl_addition1"
                                    }
                                  ],
                                  staticClass: "mt-1"
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.purpTypeCd_sub1_options
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.exterUrl_addition2 = true
                                        _vm.exterUrl_addition3 = false
                                        _vm.purpTypeCd_sub2 = undefined
                                        _vm.data.row.purpTypeCd_sub3 = undefined
                                        _vm.purpTypeCd_sub2_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                          function(cd) {
                                            return (
                                              _vm.data.row.purpTypeCd_sub1 &&
                                              cd.p_code.endsWith(
                                                _vm.data.row.purpTypeCd_sub1
                                              )
                                            )
                                          }
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.data.row.purpTypeCd_sub1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data.row,
                                          "purpTypeCd_sub1",
                                          $$v
                                        )
                                      },
                                      expression: "data.row.purpTypeCd_sub1"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.exterUrl &&
                                        _vm.exterUrl_addition1 &&
                                        _vm.exterUrl_addition2,
                                      expression:
                                        "exterUrl && exterUrl_addition1 && exterUrl_addition2"
                                    }
                                  ],
                                  staticClass: "mt-1"
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.purpTypeCd_sub2_options
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.exterUrl_addition3 = true
                                        _vm.data.row.purpTypeCd_sub3 = undefined
                                        _vm.purpTypeCd_sub3_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                          function(cd) {
                                            return (
                                              _vm.data.row.purpTypeCd_sub2 &&
                                              cd.p_code.endsWith(
                                                _vm.data.row.purpTypeCd_sub2
                                              )
                                            )
                                          }
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.data.row.purpTypeCd_sub2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data.row,
                                          "purpTypeCd_sub2",
                                          $$v
                                        )
                                      },
                                      expression: "data.row.purpTypeCd_sub2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.exterUrl &&
                                        _vm.exterUrl_addition1 &&
                                        _vm.exterUrl_addition2 &&
                                        _vm.exterUrl_addition3,
                                      expression:
                                        "exterUrl && exterUrl_addition1 && exterUrl_addition2 && exterUrl_addition3"
                                    }
                                  ],
                                  staticClass: "mt-1"
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.purpTypeCd_sub3_options
                                    },
                                    model: {
                                      value: _vm.data.row.purpTypeCd_sub3,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data.row,
                                          "purpTypeCd_sub3",
                                          $$v
                                        )
                                      },
                                      expression: "data.row.purpTypeCd_sub3"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c("th", [_vm._v("유료여부")]),
                    _c("div", { staticClass: "form-check mt-2 ml-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.payYn,
                            expression: "data.row.payYn"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          "true-value": "Y",
                          "false-value": "N",
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.data.row.payYn)
                            ? _vm._i(_vm.data.row.payYn, null) > -1
                            : _vm._q(_vm.data.row.payYn, "Y")
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.data.row.payYn,
                              $$el = $event.target,
                              $$c = $$el.checked ? "Y" : "N"
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "payYn",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.data.row,
                                    "payYn",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.data.row, "payYn", $$c)
                            }
                          }
                        }
                      }),
                      _c("label", { staticClass: "form-check-label" }, [
                        _vm._v("유료")
                      ])
                    ]),
                    _c("span", { staticClass: "mt-1 ml-2" }, [
                      _vm._v(" ※ 체크하면 유료로 전환됩니다.")
                    ])
                  ]),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mediaFile,
                          expression: "mediaFile"
                        }
                      ]
                    },
                    [
                      _c("th", [
                        _vm._v("동영상 재생"),
                        _c("br"),
                        _vm._v("시작 시간 (초)")
                      ]),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.row.playStartTime,
                              expression: "data.row.playStartTime"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''"
                            }
                          ],
                          class: {
                            "form-control": true,
                            "is-invalid": _vm.errors.has("edit.playStartTime")
                          },
                          staticStyle: { width: "200px" },
                          attrs: {
                            type: "text",
                            placeholder: "playStartTime",
                            name: "playStartTime"
                          },
                          domProps: { value: _vm.data.row.playStartTime },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.row,
                                "playStartTime",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("edit.playStartTime"),
                                expression: "errors.has('edit.playStartTime')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.contSeq) +
                                "\n                  "
                            )
                          ]
                        )
                      ]),
                      _c("th", [
                        _vm._v("동영상 재생"),
                        _c("br"),
                        _vm._v("종료 시간 (초)" + _vm._s(_vm.data.row.test))
                      ]),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.row.playEndTime,
                              expression: "data.row.playEndTime"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''"
                            }
                          ],
                          class: {
                            "form-control": true,
                            "is-invalid": _vm.errors.has("edit.playEndTime")
                          },
                          staticStyle: { width: "200px" },
                          attrs: {
                            type: "text",
                            placeholder: "playEndTime",
                            name: "playEndTime"
                          },
                          domProps: { value: _vm.data.row.playEndTime },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.row,
                                "playEndTime",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("edit.playEndTime"),
                                expression: "errors.has('edit.playEndTime')"
                              }
                            ],
                            staticClass: "invalid-feedback"
                          },
                          [_vm._v(_vm._s(_vm.errors.first("edit.playEndTime")))]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ]
        ),
        _c("div", { staticClass: "footer" }, [
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-outline-danger mr-2",
                  attrs: { variant: "outline-info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("취소")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-info mr-2",
                  attrs: { variant: "info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.s3FileUpload()
                    }
                  }
                },
                [_vm._v("저장")]
              )
            ],
            1
          )
        ])
      ]),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }